import React, { CSSProperties } from 'react'
import LottieWeb from 'lottie-react'
import { LottieViewProps} from 'lottie-react-native'

export type LottieAnimationProps = LottieViewProps & {
    style: CSSProperties
}

export const LottieAnimation = (props: LottieAnimationProps) => {
    return <LottieWeb {...props} animationData={props.source} />
}